export default __webpack_public_path__ + "static/media/IMG_025.113cc9d9.jpg";